//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "vAside",
  data() {
    return {};
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    jumpToDataQuery() {
      this.$router.push("/manage/dataQuery");
    },
    jumpToApp() {
      this.$router.push("/manage/app");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Aside.vue